import { enableProdMode, LOCALE_ID, DEFAULT_CURRENCY_CODE, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';


import {environment} from './environments/environment';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { StringifierService } from './app/services/stringifier.service';
import { AppDatePipe } from './app/pipes/app-date.pipe';
import { AppDurationPipe } from './app/pipes/app-duration.pipe';
import { ExceptionHandler } from './app/handlers/exception.handler';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutes } from './app/app.routes';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { PanelModule } from 'primeng/panel';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { PanelMenuModule } from 'primeng/panelmenu';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { BadgeModule } from 'primeng/badge';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageModule } from 'primeng/message';
import { StyleClassModule } from 'primeng/styleclass';
import { AccordionModule } from 'primeng/accordion';
import { BlockUIModule } from 'primeng/blockui';
import {AppComponent} from './app/app.component';
import {providePrimeNG} from 'primeng/config';
import {VelaBlue} from './app/themes/old-themes';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        importProvidersFrom(
            BrowserModule,
            AppRoutes,
            ReactiveFormsModule,
            ScrollPanelModule,
            ButtonModule,
            RippleModule,
            FormsModule,
            InputTextModule,
            PasswordModule,
            PanelModule,
            TooltipModule,
            DialogModule,
            ToastModule,
            ToolbarModule,
            PanelMenuModule,
            CardModule,
            ToastModule,
            TableModule,
            BadgeModule,
            MenuModule,
            MenubarModule,
            ConfirmDialogModule,
            MessageModule,
            StyleClassModule,
            AccordionModule,
            BlockUIModule,
        ),
        MessageService,
        DialogService,
        ConfirmationService,
        StringifierService,
        AppDatePipe,
        AppDurationPipe,
        providePrimeNG({
            ripple: true,
            theme: {
                preset: VelaBlue,
                options: {
                    darkModeSelector: '.dark'
                }
            }
        }),
        { provide: LOCALE_ID, useValue: 'it-IT' },
        { provide: DEFAULT_CURRENCY_CODE, useValue: '€' },
        { provide: ErrorHandler, useClass: ExceptionHandler },
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
    .catch(err => console.log(err));
